import { FieldAnswer } from '../../../lib/types/validation';

import { ValidationFieldValues } from './validation-form';

export function mapFieldAnswersToForm(
  fieldAnswers: FieldAnswer[],
): ValidationFieldValues[] {
  return fieldAnswers.map((fieldAnswer) => ({
    key: fieldAnswer.id,
    organic: (fieldAnswer.organic ? 'oui' : 'non') as 'oui' | 'non',
    last_organic: fieldAnswer.last_organic
      ? new Date(fieldAnswer.last_organic)
      : null,
    is_validated: fieldAnswer.is_validated,
  }));
}

export function canSkipAllOrganicAnswers(
  fieldAnswers: FieldAnswer[] | undefined,
  formFields: ValidationFieldValues[],
): boolean {
  if (formFields.length > 0) {
    return !formFields.some((field) => field.organic === 'oui');
  }

  return !fieldAnswers?.some((answer) => answer.organic);
}
